import type { RouteObject } from "react-router-dom";
import NotFound from "../pages/NotFound";
import Home from "../pages/home/page";
import About from "../pages/about/page";
import Exploration from "../pages/exploration/page";
import HSEPolicy from "../pages/hse-policy/page";
import Services from "../pages/services/page";
import Careers from "../pages/careers/page";
import News from "../pages/news/page";
import Contact from "../pages/contact/page";
import OEMPartnership from "../pages/oem-partnership/page";
import CSR from "../pages/csr/page";

const routes: RouteObject[] = [
  {
    path: "/",
    element: <Home />,
  },
  {
    path: "/about",
    element: <About />,
  },
  {
    path: "/exploration",
    element: <Exploration />,
  },
  {
    path: "/hse-policy",
    element: <HSEPolicy />,
  },
  {
    path: "/oem-partnership",
    element: <OEMPartnership />,
  },

  {
    path: "/services",
    element: <Services />,
  },
  {
    path: "/csr",
    element: <CSR />,
  },
  {
    path: "/careers",
    element: <Careers />,
  },
  {
    path: "/news",
    element: <News />,
  },
  {
    path: "/contact",
    element: <Contact />,
  },
  {
    path: "*",
    element: <NotFound />,
  },
];

export default routes;
